import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { logService, queueService } from '../../services';

ChartJS.register(
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  ChartDataLabels,
  BarElement,
  Title,
  Tooltip,
  Legend
);

var chartOptions = {
  responsive: true,
  aspectRation: 1,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'CC SMS Via Disposition',
    },
    datalabels: {
        display: true,
        color: "black",
        formatter: Math.round,
        anchor: "end",
        offset: 0,
        align: "start"
    }
  },
  scales: {
    x: {
        display: true,
    },
    y: {
        display: true,
        type: 'logarithmic',
    }
  }
};

// {
//         labels: labels,
//         datasets: [
//             {
//             label: 'Dataset 1',
//             data: labels.map(() => Math.random() * 100),
//             backgroundColor: 'rgba(255, 99, 132, 0.5)',
//             },
//             {
//             label: 'Dataset 2',
//             data: labels.map(() => Math.random() * 100),
//             backgroundColor: 'rgba(53, 162, 235, 0.5)',
//             },
//         ],
//     }


// const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', '1', '2', '3', '4', '5', '6']
export default function ChatStats(props) {
    const [data, setData] = React.useState({
        labels: [],
            datasets: [],
    })
    let defaultDate = new Date();
    defaultDate = new Date(defaultDate.getTime() + (3600000 * 10))
    defaultDate.setHours(0, 0, 0)
    defaultDate.setMonth(new Date().getMonth())
    defaultDate.setDate(new Date().getDate())
    console.log("callstats: " + defaultDate.getTime())
    const [start, setStart] = React.useState(Math.floor((defaultDate.getTime())/1000)); //todo get a timestamp from midnight today!
    const [callData, setCallData] = React.useState([]);
    const [triggerUpdate, setTriggerUpdate] = React.useState(false);
    const [lastProcessed, setLastProcessed] = React.useState(new Date())

    React.useEffect(() => {
        fetchData();
        const id = window.setInterval(() => setTriggerUpdate(true), 60000);
        return () => window.clearInterval(id);
    }, []);

    React.useEffect(() => {
        if (triggerUpdate) {
            fetchData(start)
            setTriggerUpdate(false)
        }
    }, [triggerUpdate])

    React.useEffect(() => {
        processLogsToData();
    }, [callData])

    const fetchData = (update) => {
        if (!update) update = start;
        queueService.getChatStats(update).then(resp => {
            // prepend new data when start is used to fetch logs.
            if (resp && resp.Success == true) {
                setCallData(resp.Data)
            }
        });
    }

    const processLogsToData = () => {
        let labels = []
        let datasets = [];
        let filteredData = {};
        //now create a dataset to add to the graph
        callData.map(d => {
        })
        datasets = [
            {
                label: 'SMS',
                backgroundColor: 'rgba(9, 55, 95, 0.5)',
                data: callData.map((v) => {
                    return v['TotalCalls'];
                })
            },
            {
                label: 'Booked',
                backgroundColor: 'rgba(16, 109, 186, 0.5)',
                data: callData.map((v) => {
                    return v['TotalBooked'];
                })
            },
            {
                label: 'Over 1 minute',
                backgroundColor: 'rgba(70, 160, 237, 0.5)',
                data: callData.map((v) => {
                    return v['OverSixy'];
                })
            },
            {
                label: 'Over 3 minutes',
                backgroundColor: 'rgba(162, 207, 246, 0.5)',
                data: callData.map((v) => {
                    return v['OverFiveHundred'];
                })
            }
        ]

        let data = {
            labels: callData.map((v) => {
                    return v['Client'].replace('client:', '').replace('_40instylesolar_2Ecom_2Eau', '');
                }),
            datasets: datasets,
        }
        setData(data)
        setLastProcessed(new Date())
    }

    const sort = (obj,valSelector) => {
        const sortedEntries = Object.entries(obj)
            .sort((a, b) =>
            valSelector(a[1]) > valSelector(b[1]) ? 1 :
            valSelector(a[1]) < valSelector(b[1]) ? -1 : 0);
        return new Map(sortedEntries);
    }

    return (
        <div style={{padding: '25px'}}>
            <div style={{textAlign: 'center'}}>From {defaultDate.toLocaleString()} to {lastProcessed.toLocaleString()}</div>
            <div style={{position: 'relative', height: '550px', margin: 'auto'}}>
                <Bar options={chartOptions} height={null} width={null} data={data} />
            </div>

        </div>

    )
}
